module.exports = __webpack_public_path__ + "public/img/出水压力.332d47f1.png";